import { SurveyQuestionType } from 'posthog-js';
import type { BasicSurveyQuestion, Survey } from 'posthog-js';

import TextArea from '../../Forms/TextArea';

import type { QuestionRendererProps } from './registry';

import styles from './OpenEndedQuestion.module.less';

type Props = QuestionRendererProps;

const isOpenQuestion = (
  q: Survey['questions'][number],
): q is BasicSurveyQuestion => q.type === SurveyQuestionType.Open;

/**
 * Renderer for PostHog `BasicSurveyQuestion` (`type: 'open'`). Renders a
 * multi-line text area via the generic `TextArea` component. Stores the
 * answer as a single string.
 */
export const OpenEndedQuestion = ({ question, value, onChange }: Props) => {
  if (!isOpenQuestion(question)) {
    return null;
  }
  return (
    <OpenEndedQuestionContent
      question={question}
      value={value}
      onChange={onChange}
    />
  );
};

type ContentProps = Props & { question: BasicSurveyQuestion };

const OpenEndedQuestionContent = ({ question, value, onChange }: ContentProps) => {
  const text = Array.isArray(value) ? '' : (value ?? '');
  return (
    <div className={styles.openEnded}>
      <p className={styles.questionText}>{question.question}</p>
      <TextArea
        label={question.question}
        value={text}
        onChange={(val) => onChange(val)}
        placeholder=""
      />
    </div>
  );
};
